import React from "react";
import { motion } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const ThemeToggle = ({ className = "", onDark = false }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  const tone = onDark
    ? "border-white/30 bg-white/10 text-white hover:bg-white/20"
    : "border-border bg-background/60 text-foreground hover:bg-muted";

  return (
    <motion.button
      type="button"
      onClick={toggleTheme}
      whileTap={{ scale: 0.9 }}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={`inline-flex h-10 w-10 items-center justify-center rounded-full border transition-colors ${tone} ${className}`}
    >
      {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </motion.button>
  );
};

export default ThemeToggle;
